<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from '@/store.js';
import DataUser from "@/js/data/controllers/DataUser.js";
import DataScrapbooks from "@/js/data/controllers/DataScrapbooks.js";

export default {
  name: 'App',
  async created () {
    if (this.$cookie.get('key')) {
      await store.dispatch('setApiKey', this.$cookie.get('key'))
      DataUser.loadData()
    } else {
      DataScrapbooks.getScrapbookData()
    }

  }
}

</script>


<style lang="scss">
  body {
    margin: 0;
    background-color: $brandBlack;
    color: $brandWhite;
  }

  h1 {
    color: $brandWhite;
  }
  img {
    max-width: 100%;
  }

</style>
